import { Directive, ElementRef, AfterContentInit } from '@angular/core';

@Directive({
    selector: '[synFocus]'
})
export class FieldFocusDirective implements AfterContentInit {

    constructor(private elementRef: ElementRef) {}

    public ngAfterContentInit(): void {
        setTimeout(
            () => this.elementRef.nativeElement.focus(),
            100,
        );
    }
}
